import { Action, createReducer, on } from '@ngrx/store';

import { AuthActions } from 'src/app/resources/authentication/actions';
import { RedirectionState } from './RedirectionState';



const reducer = createReducer<RedirectionState, Action>(
  null,

  on(AuthActions.signInFulfilled, (state, {redirectionUrl}) => {
    return state.set('redirectionUrl', redirectionUrl);
  })
);


export class RedirectionStateReducer {
  static reduce(state: RedirectionState, action: Action) {
    return reducer(state, action);
  }
}
